var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpicWin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EA9F2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9995 25.9988C20.1792 25.9988 25.9995 20.1785 25.9995 12.9988C25.9995 10.7619 25.4345 8.65691 24.4395 6.81881C22.1538 4.82132 19.1626 3.61108 15.8887 3.61108C8.70897 3.61108 2.88867 9.43138 2.88867 16.6111C2.88867 18.848 3.45366 20.953 4.44872 22.7911C6.73434 24.7886 9.7256 25.9988 12.9995 25.9988Z",
    fill: "#F5AB38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1016_12642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6492 8.02302C18.4092 7.76802 18.0688 7.62101 17.7177 7.62101H16.6002C16.6048 7.42 16.6077 7.21302 16.6077 7H9.40025C9.40025 7.21299 9.40323 7.42 9.40775 7.62101H8.28275C7.93174 7.62101 7.59125 7.76802 7.35125 8.02302C7.10823 8.27954 6.98226 8.63052 7.00323 8.98604C7.20424 12.337 8.93375 14.44 11.6757 14.752L11.1447 16.6C10.5132 16.6 10.0017 17.1115 10.0017 17.743V19H16.0077V17.743C16.0077 17.1115 15.4963 16.6 14.8648 16.6L14.3338 14.752C17.0698 14.437 18.7977 12.3355 18.9973 8.98604C19.0182 8.63204 18.8923 8.28104 18.6492 8.02302ZM8.20174 8.91402C8.20025 8.88104 8.21375 8.85854 8.22573 8.84652C8.24823 8.82253 8.27525 8.82253 8.28275 8.82253H9.46476C9.64326 11.182 10.1638 12.52 10.6693 13.276C8.74476 12.469 8.28573 10.3135 8.20174 8.91402ZM15.3388 13.2715C15.8442 12.514 16.3633 11.1775 16.5417 8.82104H17.7192C17.7282 8.82104 17.7538 8.82104 17.7763 8.84503C17.7883 8.85704 17.8017 8.87954 17.8002 8.91253C17.7148 10.312 17.2573 12.4615 15.3388 13.2715Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1016_12642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicWin);
export default __webpack_public_path__ + "static/media/epic-win.c5d1cbaf2a3e9b962a499b1be0fa21fe.svg";
export { ForwardRef as ReactComponent };